import { useEffect } from "react";

type SeoProps = {
  title: string;
  description: string;
  keywords: string;
  path: string;
  type?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
};

const SITE_ORIGIN = "https://jingzhehui.cn";

const setMeta = (attr: "name" | "property", key: string, content: string) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel: string, href: string) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const buildUrl = (path: string) => {
  const base = typeof __BASE_PATH__ === "string" ? __BASE_PATH__ : "/";
  const prefix = base.replace(/\/$/, "");
  const clean = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_ORIGIN}${prefix}${clean === "/" ? "" : clean}`;
};

export default function Seo({
  title,
  description,
  keywords,
  path,
  type = "website",
  jsonLd,
}: SeoProps) {
  useEffect(() => {
    const url = buildUrl(path);
    document.title = title;
    document.documentElement.lang = "zh-CN";

    setMeta("name", "description", description);
    setMeta("name", "keywords", keywords);
    setMeta("name", "robots", "index, follow, max-image-preview:large");
    setMeta("name", "author", "黑瓜爆料编辑部");

    setLink("canonical", url);

    setMeta("property", "og:type", type);
    setMeta("property", "og:site_name", "黑瓜爆料");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:locale", "zh_CN");

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    const scriptId = "heigua-jsonld";
    const existing = document.getElementById(scriptId);
    if (existing) {
      existing.remove();
    }
    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = scriptId;
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, keywords, path, type, jsonLd]);

  return null;
}